import React from 'react';

import {
  QuerySection,
  LayoutSection,
  SaveSection,
} from './components/sections/advanced-search';
import { OtherLayout } from './components';
import { RibbonBar, RibbonDivider } from 'common/components';
import ManageSharingSection from './components/sections/shared/ManageSharingSection';
import DetailSection from './components/sections/home-grid/DetailSection';
import { ViewLayout, AdvanceStack } from './components';
import OpenResultControl from './components/controls/advanced-search/OpenResultControl';
import { useFolderByLevel } from 'hooks/useFolderByLevel';
import OpenSchedule from './components/controls/advanced-search/OpenSchedule';

const ReportingFullViewRibbon = (props) => {
  const {
    type,
    disabledSaveQuery,
    disabledExportQuery,
    disableRun,
    modeData,
    onClickRibbonBtn,
    modeView,
    selectedResult,
    isOwner,
    dataQueryConditions,
  } = props;

  const { shouldKeepFolderBreadcrumb, keepFolderBreadcrumb } =
    useFolderByLevel();

  const closeDetailCallback = () => {
    //* keep folder breadcrumb when close folder item detail
    shouldKeepFolderBreadcrumb && keepFolderBreadcrumb(true);
  };

  return (
    <RibbonBar>
      <ManageSharingSection />
      <DetailSection />
      <ViewLayout disabled={true} />
      <RibbonDivider />

      <QuerySection
        modeData={modeData}
        disableRun={disableRun}
        onClickRibbonBtn={onClickRibbonBtn}
        disabledExportQuery={disabledExportQuery}
        type={type}
        dataQueryConditions={dataQueryConditions}
      />
      <SaveSection
        disableSave={disabledSaveQuery}
        onClickRibbonBtn={onClickRibbonBtn}
        modeView={modeView}
        isOwner={isOwner}
      />
      <RibbonDivider />
      <LayoutSection
        onClickRibbonBtn={onClickRibbonBtn}
        type={type}
        modeView={modeView}
      />
      <OpenResultControl
        type={type}
        selectedResult={selectedResult}
        onClickRibbonBtn={onClickRibbonBtn}
      />
      <OpenSchedule modeData={modeData} />

      <RibbonDivider />
      <AdvanceStack isDisabled={true} />
      <OtherLayout
        ribbonSide='right'
        ribbonType='reportings'
        closeDetailCallback={closeDetailCallback}
      />
    </RibbonBar>
  );
};

ReportingFullViewRibbon.propTypes = {};

export default ReportingFullViewRibbon;
